import mixpanel from 'mixpanel-browser';

let isInitialized = false;

// Initialize Mixpanel
const initMixpanel = () => {
  const token = process.env.REACT_APP_MIXPANEL_TOKEN;

  if (token && !isInitialized) {
    try {
      mixpanel.init(token, {
        debug: process.env.NODE_ENV === 'development',
        track_pageview: true,
        persistence: 'localStorage',
        api_host: 'https://api.mixpanel.com',
        loaded: () => {
          isInitialized = true;
          console.log('Mixpanel initialized successfully');
        }
      });
    } catch (error) {
      console.error('Mixpanel initialization failed:', error);
    }
  } else if (!token) {
    console.warn('Mixpanel token not found');
  }
};

// Track events with safety checks (non-blocking)
export const trackEvent = (eventName, properties = {}) => {
  // Make tracking non-blocking using setTimeout to prevent UI delays
  setTimeout(() => {
    try {
      // Check if Mixpanel is properly initialized
      if (isInitialized && mixpanel && typeof mixpanel.track === 'function') {
        mixpanel.track(eventName, properties);
      } else if (process.env.NODE_ENV === 'development') {
        console.log('Mixpanel Event (not tracked):', eventName, properties);
      }
    } catch (error) {
      console.error('Mixpanel tracking error:', error);
    }
  }, 0);
};

// Track user properties
export const identifyUser = (userId, properties = {}) => {
  try {
    if (isInitialized && mixpanel && typeof mixpanel.identify === 'function') {
      mixpanel.identify(userId);
      if (mixpanel.people && typeof mixpanel.people.set === 'function') {
        mixpanel.people.set(properties);
      }
    }
  } catch (error) {
    console.error('Mixpanel identify error:', error);
  }
};

export default {
  init: initMixpanel,
  track: trackEvent,
  identify: identifyUser
};